import { render, staticRenderFns } from "./course_stu.vue?vue&type=template&id=dcfd7232&scoped=true&"
import script from "./course_stu.vue?vue&type=script&lang=js&"
export * from "./course_stu.vue?vue&type=script&lang=js&"
import style0 from "./course_stu.vue?vue&type=style&index=0&id=dcfd7232&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfd7232",
  null
  
)

export default component.exports